import { render, staticRenderFns } from "./FeedbackPromotion.vue?vue&type=template&id=c2dad612&scoped=true"
import script from "./FeedbackPromotion.vue?vue&type=script&lang=js"
export * from "./FeedbackPromotion.vue?vue&type=script&lang=js"
import style0 from "./FeedbackPromotion.vue?vue&type=style&index=0&id=c2dad612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dad612",
  null
  
)

export default component.exports